<template>
  <div v-if="searchList.length && !loading" class="result-container">
    <button
      v-for="(item, idx) in searchList"
      :key="idx"
      :disabled="item.accountStatus !== 'Active'"
      type="button"
      :class="['result-item', item.accountStatus !== 'Active' ? 'disabled' : '']"
      @click="navigateTo(`/member/${item.customerId}`)"
    >
      <span class="grid-row">
        <span class="sac__font-14 med">
          {{ item.firstName + " " + item.lastName }} - {{ item.companyName }}
          <span v-if="item.planName" class="sac-tag-small f-yellow size-10">{{ item.planName }}</span>
        </span>
        <span class="sac__font-12 n70 semi-bold">
          {{ item.uid }}
        </span>
        <span class="sac__font-10 n50 med">
          {{ item.fullAddress }}
        </span>
      </span>
      <span v-if="item.accountStatus !== 'Active'" class="sac-tag size-12 r-8 f-disabled">
        {{ item.accountStatus }}
      </span>
      <span v-else-if="isSmacAdmin" class="grid-column ai-c gap-16">
        <button
          type="button"
          class="result-btn bg-primary"
          @click="navigateTo(`/device/${item.uid}`)"
        >
          <img
            src="@shared/assets/img/navbar/device.png"
            alt="search"
            class="img-size-16"
          />
          <span>Device</span>
        </button>
        <button
          type="button"
          class="result-btn bg-navy"
          @click="navigateTo(`/support/${item.uid}`)"
        >
          <img
            src="@shared/assets/img/navbar/qc.png"
            alt="search"
            class="img-size-16"
          />
          <span>Support</span>
        </button>
      </span>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CustomerResultList',
  props: {
    searchList: Array,
    loading: Boolean,
  },
  computed: {
    ...mapGetters([
      'isSmacAdmin',
    ]),
  },
  methods: {
    navigateTo(url) {
      window.open(url, '_blank').focus();
    },
  },
};
</script>

<style scoped lang="scss">
.result-container {
  overflow-y: auto;
  margin-top: 1rem;
  display: grid;
  gap: 8px;
  scrollbar-width: none;
  .result-item {
    padding: 8px;
    gap: 1rem;
    display: grid;
    cursor: pointer;
    background-color: $N5;
    border-radius: 6px;
    grid-auto-flow: column;
    justify-content: space-between;
    text-align: left;
    align-items: center;
    &.disabled {
      cursor: not-allowed;
      &:hover {
        background-color: $N5;
      }
    }
    .result-btn {
      border-radius: 4px;
      padding: 4px 8px;
      color: $WHITE;
      font-size: 10px;
      font-weight: 500;
      display: grid;
      align-items: center;
      grid-auto-flow: column;
      gap: 8px;
      &.bg-navy {
        background-color: $NAVY100;
      }
      &.bg-primary {
        background-color: $NBLUE100;
      }
    }
  }
}
</style>
